import { render, staticRenderFns } from "./CheckModel.vue?vue&type=template&id=7f808767&scoped=true"
import script from "./CheckModel.vue?vue&type=script&lang=js"
export * from "./CheckModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f808767",
  null
  
)

export default component.exports